import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PipelineLicenseStakeholderDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-pipeline-license-stakeholder',
  templateUrl: './pipeline-license-stakeholder.component.html',
  styleUrls: ['./pipeline-license-stakeholder.component.scss']
})
export class PipelineLicenseStakeholderComponent implements OnChanges {

  pipelinelicensestakeholderForm: FormGroup;
  pipelinelicensestakeholderFormArray: FormGroup;
  control = new FormControl();
  @Input() pipelinelicensestakeholders: PipelineLicenseStakeholderDto[];
  @Input() routeAnimationsElements: any;
  @Output() pipelinelicensestakeholder = new EventEmitter<PipelineLicenseStakeholderDto[]>();
  @Output() deletePipelineLicenseStakeholderEvent = new EventEmitter<any>();

  selectedPipelineLicenseStakeholder: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createPipelineLicenseStakeholderForm();
  }

  createPipelineLicenseStakeholderForm() {
    this.pipelinelicensestakeholderForm = this.fb.group({
      PipelineLicenseStakeholderName: ['', Validators.required],
      id: null,
    });
    this.pipelinelicensestakeholderFormArray = this.fb.group({
      PipelineLicenseStakeholders: this.fb.array([]),
    });
    this.setPipelineLicenseStakeholder();
  }

  // method to display pipelinelicensestakeholders
  setPipelineLicenseStakeholder() {
    const control = this.pipelinelicensestakeholderFormArray.controls.PipelineLicenseStakeholders as FormArray;
    this.pipelinelicensestakeholders.forEach((e) => {
      control.push(
        this.fb.group({
          PipelineLicenseStakeholderName: e.PipelineLicenseStakeholderName,
          id: e.id,
        })
      );
    });
  }

  // method to add PipelineLicenseStakeholder
  addPipelineLicenseStakeholder(value: PipelineLicenseStakeholderDto) {
    const control = this.pipelinelicensestakeholderFormArray.controls.PipelineLicenseStakeholders as FormArray;
    control.insert(
      0,
      this.fb.group({
        PipelineLicenseStakeholderName: value.PipelineLicenseStakeholderName,
        id: null,
      })
    );
  }

  selectPipelineLicenseStakeholder(value) {}

  // method to delete pipelinelicensestakeholder from arrary list
  deletePipelineLicenseStakeholder(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.pipelinelicensestakeholderFormArray.controls.PipelineLicenseStakeholders as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.pipelinelicensestakeholders.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.pipelinelicensestakeholders[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: PipelineLicenseStakeholderDto) {
    if (this.pipelinelicensestakeholderForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.pipelinelicensestakeholderFormArray
        .get('PipelineLicenseStakeholders')
        ['controls'][this.selectedIndex].patchValue({
          PipelineLicenseStakeholderName: formValue.PipelineLicenseStakeholderName,
        });
    } else {
      this.addPipelineLicenseStakeholder(formValue);
    }
    this.selectedIndex = null;
    this.pipelinelicensestakeholderForm.reset();
  }

  onEdit(index, value: PipelineLicenseStakeholderDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.pipelinelicensestakeholderForm.patchValue({ PipelineLicenseStakeholderName: value.PipelineLicenseStakeholderName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.pipelinelicensestakeholderForm.reset();
  }

  onSubmit(formValue: PipelineLicenseStakeholderDto[]) {
    this.pipelinelicensestakeholder.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deletePipelineLicenseStakeholderEvent.emit(this.filteredDelete);
    }
  }
}